import AuthService from "@/new/services/AuthService";

export function getImageSrc(imageUrl) {

    const axios = typeof require === 'function'
        ? require('axios')
        : window.Axios;
    if (!axios) {
        throw new Error('[auth-image] cannot locate Axios');
    }
    return axios({
        headers: {
            'Authorization': 'Bearer ' + AuthService.getAccessToken()
        },
        method: 'get',
        url: imageUrl,
        responseType: 'arraybuffer'
    }).then(function (resp) {
        resp = resp.response;
        const mimeType = resp.headers['content-type'].toLowerCase();
        const imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
        return 'data:' + mimeType + ';base64,' + imgBase64;
    }).catch((function () {
        return imageUrl;
    }))
}
